import { Inject, Injectable } from '@angular/core'
import { LOGGER_SERVICE } from '../logger/logger.config'
import { LoggerService } from '../logger/logger.interface'
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http'
import { combineLatest, Observable, of } from 'rxjs'
import { catchError, switchMap } from 'rxjs/operators'
import type { MultipleSectionsViewModel } from '@flocasts/experience-service-types'
import { EXPERIENCE_API_RESULTS_BASE_PATH } from '../app.config'
import { getResultsIndexExperienceParams } from './results-data.functions'
import {
  EXP_NEXT_GEN_EVENT_HUB_WRESTLING,
  EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT,
  EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT_VARIATION,
  EXP_NEXT_GEN_EVENT_HUB_WRESTLING_VARIATION
} from '../shared/experimentation/experiment.model'
import { ExperimentationService } from '../shared/experimentation/experimentation.service'

@Injectable({
  providedIn: 'root'
})
export class ResultsDataService {
  constructor(
    @Inject(LOGGER_SERVICE) private readonly logger: LoggerService,
    private readonly http: HttpClient,
    private readonly experimentationService: ExperimentationService
  ) {}
  public readonly isNextGenEventHub$ = this.experimentationService.isInVariation(
    EXP_NEXT_GEN_EVENT_HUB_WRESTLING,
    EXP_NEXT_GEN_EVENT_HUB_WRESTLING_VARIATION,
    false
  )
  public readonly isNextGenEventHubShort$ = this.experimentationService.isInVariation(
    EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT,
    EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT_VARIATION,
    false
  )
  public getResultsIndexExperience(
    search?: string,
    date?: string,
    timezone?: string,
    navId?: string,
    isInEventHubBracketsVariation?: boolean
  ): Observable<MultipleSectionsViewModel> {
    return combineLatest([this.isNextGenEventHub$, this.isNextGenEventHubShort$]).pipe(
      switchMap(([isNextGenEventHub, isNextGenEventHubShort]) => {
        // TODO: FLO-15099 pagination will be added, and these values will not be hardcoded
        let params = new HttpParams({
          fromObject: getResultsIndexExperienceParams(
            timezone,
            navId,
            isInEventHubBracketsVariation,
            isNextGenEventHub || isNextGenEventHubShort
          )
        })
        params = search ? params.set('search', search) : params
        const path = date ? `${EXPERIENCE_API_RESULTS_BASE_PATH}/${date}` : EXPERIENCE_API_RESULTS_BASE_PATH
        return this.http.get<MultipleSectionsViewModel>(path, { params }).pipe(
          catchError((error: HttpErrorResponse) => {
            this.logger.error('Results Data Service Error: ', error)
            // TODO - return type MessageModel instead of {}
            return of({} as MultipleSectionsViewModel)
          })
        )
      })
    )
  }
}
